var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "table",
      [
        _vm._m(0),
        _vm._v(" "),
        _vm._l(_vm.providers, function(provider, index) {
          return _c("providerRow", {
            key: index,
            attrs: { tag: "tr", provider: provider, type: _vm.type }
          })
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container", staticStyle: { width: "100%" } }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticStyle: { float: "left" } }, [
          !_vm.isFirstPage
            ? _c(
                "button",
                {
                  staticClass: "nav-button",
                  staticStyle: { "border-width": "1px" },
                  on: {
                    click: function($event) {
                      return _vm.$store.commit("prevPage", 1)
                    }
                  }
                },
                [_c("span", [_vm._v("← Prev")])]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { float: "right" } }, [
          !_vm.isLastPage
            ? _c(
                "button",
                {
                  staticClass: "nav-button",
                  staticStyle: { "border-width": "1px" },
                  on: {
                    click: function($event) {
                      return _vm.$store.commit("nextPage", 1)
                    }
                  }
                },
                [_c("span", [_vm._v("Next →")])]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Name")]),
      _vm._v(" "),
      _c("th", [_vm._v("Logo")]),
      _vm._v(" "),
      _c("th", [_vm._v("Details")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f7eb1c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f7eb1c0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/displayAndSelect.vue
// module id = 162
// module chunks = 0